<template>
  <div
    v-if="doc"
    :class="[
      'document d-flex align-items-center justify-content-start text item px-3 py-3',
      selected ? 'selected' : 'border',
			docStatusType
    ]"
    @click="$emit('click', doc)"
  >
    <el-avatar v-if="doc.icon" :icon="doc.icon" shape="square"></el-avatar>

    <div class="ml-3 w-100-OFF flex-fill">

      <div class="font-weight-bold-OFF" style="font-size: 0.70rem;">{{ doc.document_type ? doc.document_type.name : '' }}</div>

      <el-tag class="mt-2" size="small" :type="docStatusType" effect="plain">
        {{ doc.file_name | trim(40) }}
      </el-tag>

			<el-tag size="small" :type="docStatusType">{{doc.status}}</el-tag>

      <!-- <small class="d-block">{{ doc.file_name }}</small> -->
      <div class="mt-2 d-flex align-items-center justify-content-between">
        <!-- <small>{{ doc.applicant ? doc.applicant.full_name : "Anonymous" }}</small> -->
        <small>{{ doc.uploader_name }}</small>
        <small v-if="doc.created_at">
          {{ (doc.created_at + "Z") | moment("DD/MM/YYYY hh:mm:ss A") }}
        </small>
        <small v-if="doc.file_size">
          Size: {{ (doc.file_size / 1024).toFixed(2) }} KB
        </small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DocumentCard",
  components: {},
  props: {
    doc: { type: Object, default: () => ({}) },
    selected: { type: Boolean, default: false }
  },
  data() {
    return {}
  },
  computed: {
		docStatusType() {
			if (this.doc.status == 'Approved') {
				return 'success';
			} else if (this.doc.status == 'Pending') {
				return 'warning';
			} else if (this.doc.status == 'Rejected') {
				return 'danger';
			}
		},
	},
  watch: {},
  mounted() {

	},
  updated() {},
  activated() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';

.document {
  $color-selected: #5cbb2a;
  $color-not-verified: #e6a23c;
  $color-rejected: #f56c6c;
  cursor: pointer;
  &.selected {
    border: 1px solid $color-selected;
    background-color: rgba($color-selected, 0.03);
  }
	&.success {
		border: 1px solid $color-selected;
    background-color: rgba($color-selected, 0.03);
	}
	&.warning {
		border: 1px solid $color-not-verified !important;
    background-color: rgba($color-not-verified, 0.03) !important;
	}
	&.danger {
		border: 1px solid $color-rejected !important;
    background-color: rgba($color-rejected, 0.03) !important;
	}
}
</style>
